// extracted by mini-css-extract-plugin
export default {"root":"FKYLgqLaX2M5pBb8XgdF","active":"g8Ctza3ivTamJSOcjsyM","placeHolderShimmer":"xd9q5bkl10p8ayoUpsLr"};